export const MunicipalityFixedProperty = {
  CertificationStatus: 'Certification Status'
};